import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Zap, Moon, Dumbbell, ShieldCheck, Check } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const bullets = [{
    icon: <Sparkles className="w-4 h-4 text-gold" data-id="element-323" />,
    text: 'Piel luminosa y firme'
  }, {
    icon: <Zap className="w-4 h-4 text-gold" data-id="element-324" />,
    text: 'Energía natural sostenida'
  }, {
    icon: <Moon className="w-4 h-4 text-gold" data-id="element-325" />,
    text: 'Sueño profundo y reparador'
  }, {
    icon: <Dumbbell className="w-4 h-4 text-gold" data-id="element-326" />,
    text: 'Masa muscular preservada'
  }];
  return <section className="relative pt-10 pb-12 md:pt-24 md:pb-32 px-6 overflow-hidden bg-cream-light bg-noise" data-id="element-327">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 w-[800px] h-[800px] bg-olive-light/5 rounded-full blur-3xl pointer-events-none" data-id="element-328" />
      <div className="absolute bottom-0 left-0 translate-y-1/4 -translate-x-1/4 w-[600px] h-[600px] bg-gold-light/5 rounded-full blur-3xl pointer-events-none" data-id="element-329" />

      <div className="max-w-7xl mx-auto grid lg:grid-cols-[1.1fr_0.9fr] gap-12 lg:gap-16 items-center relative z-10" data-id="element-330">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="space-y-7 md:space-y-10" data-id="element-331">
          <div className="space-y-6" data-id="element-332">
            <div className="flex items-center gap-3" data-id="element-333">
              <div className="h-px w-8 bg-gold/50" data-id="element-334" />
              <p className="text-xs md:text-sm font-medium tracking-[0.2em] text-gold uppercase" data-id="element-335">
                Wellaging Argentino · Método 360°
              </p>
            </div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-charcoal leading-[1.1] tracking-tight" data-id="element-336">
              Tu cuerpo no está envejeciendo.
              <br data-id="element-337" />
              Está esperando que lo{' '}
              <span className="italic text-gold font-light" data-id="element-338">escuches.</span>
            </h1>
            <p className="text-lg md:text-xl text-charcoal-light font-light leading-relaxed max-w-2xl" data-id="element-339">
              La mayoría de las mujeres argentinas de 40-60 años pierde energía,
              firmeza y vitalidad cada año... no porque "así sea envejecer",
              sino porque nunca les enseñaron cómo cuidar su cuerpo
              correctamente en esta etapa.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-xl" data-id="element-340">
            {bullets.map((bullet, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5 + idx * 0.1
          }} className="glass-card p-4 rounded-2xl flex items-center gap-3" data-id="element-341">
                <div className="bg-gold/10 p-2 rounded-full shadow-[0_0_15px_rgba(201,169,97,0.2)]" data-id="element-342">
                  {bullet.icon}
                </div>
                <span className="text-sm text-charcoal font-medium" data-id="element-343">
                  {bullet.text}
                </span>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.9
        }} className="pt-4 space-y-6" data-id="element-344">
            <Button fullWidth href="#precio" onClick={e => {
            e.preventDefault();
            document.getElementById('precio')?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }} className="text-xl" subtext="$17.990 · Acceso inmediato" data-id="element-345">
              Quiero empezar mi Wellaging
            </Button>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 sm:gap-6 text-sm text-charcoal-light font-light" data-id="element-346">
              <div className="flex items-center gap-2" data-id="element-347">
                <Check className="w-4 h-4 text-gold" data-id="element-348" />
                <span data-id="element-349">Solo 500 copias a este precio</span>
              </div>
              <div className="hidden sm:block text-gold/30" data-id="element-350">|</div>
              <div className="flex items-center gap-2" data-id="element-351">
                <ShieldCheck className="w-4 h-4 text-gold" data-id="element-352" />
                <span data-id="element-353">Garantía de 30 días</span>
              </div>
            </div>

            {/* Press / Media mention */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 1.1
          }} className="pt-8 mt-2" data-id="element-354">
              <p className="text-xs text-charcoal-light/60 uppercase tracking-widest mb-6 text-center lg:text-left" data-id="element-355">
                Mencionado en medios
              </p>
              <div className="flex justify-center lg:justify-start" data-id="element-356">
                <div className="relative max-w-[420px] md:max-w-[520px] lg:max-w-[560px] w-full" data-id="element-357">
                  {/* Soft olive glow behind phone */}
                  <div className="absolute inset-0 bg-olive/10 blur-3xl rounded-full scale-90" data-id="element-358" />
                  <img src="https://cdn.magicpatterns.com/uploads/h97mBsixL9UHFKpC1Z7Fqc/Diseno_sin_titulo.png" alt="Wellaging mencionado en Infobae" width={560} height={300} loading="lazy" decoding="async" className="relative w-full h-auto mix-blend-multiply" data-id="element-359" />
                </div>
              </div>
            </motion.div>
          </motion.div>

          {/* Authority Badges */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1.2
        }} className="pt-8 border-t border-charcoal/5 text-center lg:text-left" data-id="element-360">
            <p className="text-xs text-charcoal-light/60 uppercase tracking-widest mb-4" data-id="element-361">
              Basado en investigaciones de
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 opacity-60 grayscale" data-id="element-362">
              <span className="font-serif font-bold text-lg md:text-xl" data-id="element-363">
                COSMOPROF
              </span>
              <span className="font-serif italic text-lg md:text-xl" data-id="element-364">
                The Guardian
              </span>
              <span className="font-sans font-bold tracking-tighter text-base md:text-lg" data-id="element-365">
                COSMETICS BUSINESS
              </span>
            </div>
          </motion.div>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.2,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative h-[380px] lg:h-[800px] w-full mt-6 lg:mt-0" data-id="element-366">
          {/* Soft olive blob */}
          <div className="absolute inset-0 bg-olive rounded-[3rem] rotate-3 scale-95 opacity-10 transition-transform duration-700 hover:rotate-6" data-id="element-367" />

          <div className="relative w-full h-full rounded-[3rem] overflow-hidden shadow-soft border border-gold/20 p-2 bg-white/50 backdrop-blur-sm" data-id="element-368">
            <img src="https://cdn.magicpatterns.com/uploads/kMmxfdWmpfwWRjaePj745t/avatar.jpg" alt="Mujer argentina vital en su cocina" width={800} height={1000} loading="eager" fetchPriority="high" decoding="async" className="w-full h-full object-cover rounded-[2.5rem]" data-id="element-369" />
          </div>

          {/* Floating badge */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 1.2
        }} className="absolute bottom-8 -left-4 md:bottom-16 md:-left-12 glass-card p-4 md:p-5 rounded-2xl flex items-center gap-4 max-w-[260px]" data-id="element-370">
            <div className="bg-olive p-3 rounded-full text-gold shrink-0" data-id="element-371">
              <Sparkles className="w-5 h-5 md:w-6 md:h-6" data-id="element-372" />
            </div>
            <div data-id="element-373">
              <p className="font-serif font-bold text-charcoal text-base md:text-lg" data-id="element-374">
                5.278+
              </p>
              <p className="text-[10px] md:text-xs text-charcoal-light font-light uppercase tracking-wider" data-id="element-375">
                Argentinas transformadas
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}